module.exports = __webpack_public_path__ + "static/images/uchoice_tiktok_logo2.e0c71664ececde7dd11d470ef8962382.png";